import { useQuery } from "@tanstack/react-query";
import { getProvider } from "./providersApi";

interface UseProviderWithIdOptions {
  readonly enabled?: boolean;
}

export const useProviderWithId = (providerId: string | undefined, options: UseProviderWithIdOptions = {}) => {
  const { enabled = true } = options;
  const { data, isLoading } = useQuery({
    queryKey: ["providers", providerId],
    queryFn: ({ signal }) => getProvider(providerId!, signal),
    enabled: enabled && !!providerId,
  });

  return { provider: data, isLoading };
};
